import { render, staticRenderFns } from "./applyForActivation.vue?vue&type=template&id=1e065d93&scoped=true"
import script from "./applyForActivation.vue?vue&type=script&lang=js"
export * from "./applyForActivation.vue?vue&type=script&lang=js"
import style0 from "./applyForActivation.vue?vue&type=style&index=0&id=1e065d93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e065d93",
  null
  
)

export default component.exports